<template>
  <div class="has-border-b filters filters--company white">
    <div class="filters-title">
      <v-icon color="gray-6">filter_list</v-icon>
      {{ $t('Common.filters') }}
    </div>

    <div class="filters-item filters-item--search filters-item--reset">
      <v-text-field
        v-model="filters.search"
        :placeholder="$t(`${namespace}.placeholder`)"
        prepend-inner-icon="search"
        :disabled="!isSuccess"
        :loading="searchIsLoading"
        color="accent"
        height="36"
        flat
        solo
        clearable
        hide-details
        @input="handleSearch"
      />
    </div>

    <div class="filters-item">
      <MenuItemAutocomplete
        type="requester"
        :status="status"
        @change="updateFilters"
      />
    </div>

    <div class="filters-item filters-item__border">
      <MenuItemAutocomplete
        type="approver"
        :status="status"
        @change="updateFilters"
      />
    </div>

    <div class="filters-item filters-item__border">
      <MenuItemPeriod
        type="orderedOn"
        :status="status"
        @change="updateFilters"
      />
    </div>

    <div class="filters-item filters-item__border">
      <MenuItemPeriod
        type="expectedDate"
        :status="status"
        @change="updateFilters"
      />
    </div>

    <div class="filters-item filters-item__border">
      <MenuItemStatus :status="status" @change="updateFilters" />
    </div>
  </div>
</template>

<script>
import debounce from 'lodash.debounce'
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import MenuItemAutocomplete from 'components/company/anonymousCompanies/MenuItemAutocomplete'
import MenuItemPeriod from 'components/company/anonymousCompanies/MenuItemPeriod'
import MenuItemStatus from 'components/company/anonymousCompanies/MenuItemStatus'

export default {
  name: 'Filters',
  props: {
    status: {
      type: Number,
      default: STATUS_IS_LOADING
    }
  },
  components: {
    MenuItemAutocomplete,
    MenuItemPeriod,
    MenuItemStatus
  },
  computed: {
    isLoading () {
      return this.status === STATUS_IS_LOADING
    },

    isSuccess () {
      return this.status === STATUS_SUCCESS
    },

    isFailed () {
      return this.status === STATUS_FAILED
    },

    searchIsLoading () {
      return this.isLoading && Boolean(this.filters.search)
    }
  },
  data () {
    return {
      namespace: 'Views.CompanyPage.companies',
      filters: {
        requesterEmail: null,
        confirmerEmail: null,
        requestDate: null,
        confirmationDate: null,
        scheduledDate: null,
        status: null,
        search: null
      }
    }
  },
  methods: {
    emitEvent () {
      this.$emit('change', this.filters)
    },

    handleSearch: debounce(function () {
      this.emitEvent()
    }, 1000),

    updateFilters (val) {
      this.filters = {
        ...this.filters,
        ...val
      }

      this.emitEvent()
    }
  }
}
</script>

<style lang="scss">
.filters--company {

  .filters-item.filters-item--search {
    width: 310px;
  }
}
</style>
